/**
 * SA-6 — MSR Commission Estimator (forward-looking "what could I earn"), authenticated in-CRM page.
 * Inputs + live itemized display live in the shared CommissionEstimatorForm (also used by the standalone
 * public /commission-estimator-public tool). Rates come from the authenticated commission_estimator_rates
 * read; pure math lives in utils/commissionEstimator (unit-tested).
 */
import { useQuery } from "@tanstack/react-query";
import { getCommissionEstimatorRates } from "../services/commissionEstimator.service";
import CommissionEstimatorForm from "../components/commission/CommissionEstimatorForm";

export default function CommissionEstimator() {
  const {
    data: rates,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["commission-estimator-rates"],
    queryFn: getCommissionEstimatorRates,
    staleTime: 10 * 60 * 1000,
  });

  return (
    <div className="mx-auto max-w-4xl p-6">
      <h1 className="mb-1 text-2xl font-bold text-gray-900">
        Commission Calculator
      </h1>

      {isLoading && <p className="text-sm text-gray-500">Loading rates…</p>}
      {error && (
        <p className="text-sm text-red-600">
          Could not load commission rates. Please try again.
        </p>
      )}
      {!isLoading && !error && <CommissionEstimatorForm rates={rates ?? []} />}
    </div>
  );
}
